import { DashboardDetailRequest } from "../../../../../shared/models/dashboard";

export interface DashboardChartSummaryItem {
  label: string;
  value: number;
  color: string;
}

export interface DashboardChartSummary {
  items: DashboardChartSummaryItem[];
  total: number;
  valueLabel: string;
}

export interface DashboardDataViewTransfer {
  title: string;
  columns: string[];
  chartImage?: string;
  chartSummary?: DashboardChartSummary;
  request: DashboardDetailRequest;
}

export const DASHBOARD_DATA_STORAGE_PREFIX = "dashboard-data-view:";
